import { blue } from "@ant-design/colors";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  Box,
  Field,
  FieldError,
  FieldInput,
  FieldLabel,
  Flex,
  IconButton,
  Typography,
} from "@strapi/design-system";
import { Grid, GridItem } from "@strapi/design-system/Grid";
import { Button, Card, Col, Modal, Popconfirm, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Template from "../../asset/form/5. Bieu_mau_noi_dung_tom_tat_luan_an.docx";
import TemplateEn from "../../asset/form/thesis_summary_template.docx";
import { infoList, isValidPhoneNumber } from "../../util/helper";
import DegreeSelect from "../degreeSelect";
import Prizesv2 from "../form/Prizesv2";
import SchoolRanking from "../form/SchoolRanking";
import ThesisMember from "../form/ThesisMember";
import ThesisResult from "../form/ThesisResult";

import UploadFile from "../uploadFile";

const ThesisTab = ({
  dataForUpdate,
  setDataForUpdate,
  isSecretariatView = false,
}) => {
  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);

  //#region Form
  const [curObject, setCurObject] = useState(null);
  const [curIndex, setCurIndex] = useState(null);
  const [key, setKey] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [modalTile, setModalTitle] = useState("");
  const [rankingType, setRankingType] = useState(null);
  //#endregion

  const [fileList, setFileList] = useState([]);
  const [downloadTemplate, setDownloadTemplate] = useState(null);


  //#region Columns

  //#region currentpage table
  const [instructorDetailCurrentPage, setInstructorDetailCurrentPage] = useState(1);
  const [membersCurrentPage, setMembersCurrentPage] = useState(1);
  const [thesisResultsCurrentPage, setThesisResultsCurrentPage] = useState(1);
  const [rankingCurrentPage, setRankingCurrentPage] = useState(1);
  const [pageSizeTable, setPageSizeTable] = useState(10);

  //#endregion
  const rankingColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_ranking")}`,
      key: "name",
      render: (value, record) => {
        return (
          <div>
            <Typography variant="pi" fontWeight="bold">
              {record?.key === "school_rank"
                ? t("str_school_ranking")
                : t("str_ranking_nominee_major")}
            </Typography>
            <br />
            <span>
              {t("str_domestic")}: {record?.domestic}
            </span>
            <br />
            <span>
              {t("str_international")}: {record?.international}
            </span>
          </div>
        );
      },
    },
    {
      title: `${t("str_ranking_organization")}`,
      dataIndex: "organization_rank",
    },
    {
      title: `${t("str_note")}`,
      dataIndex: "note",
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("school_ranking", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              {index >= 2 && (
                <Box paddingLeft={1}>
                  <Popconfirm
                    onConfirm={() => handleDeleteRanking(index)}
                    title={t("str_confirm")}
                    description={t("str_confirm_delete")}
                    okText={t("str_yes")}
                    cancelText={t("str_no")}
                  >
                <IconButton noBorder icon={<DeleteOutlined />} />
              </Popconfirm>
            </Box>
          )}
            </Flex>
          );

        return null;
      },
    },
  ];

  const thesisMemberColumns = [
    {
      title: `${t("str_ordinal_number_TT")}`,
      key: "index",
      render: (value, record, index) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_full_name")}`,
      dataIndex: "name",
    },
    {
      title: `${t("str_nominator_academic_rank_degree")}`,
      dataIndex: "degree",
    },
    {
      title: `${t("str_work_unit")}`,
      dataIndex: "working_unit",
    },
    {
      title: `${t("str_evaluation_content")}`,
      dataIndex: "content",
    },
    {
      title: `${t("str_attach_proof")}`,
      key: "url",
      render: (value, record) => {
        let attachment = null;

        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (
          <Flex direction="column" alignItems="flex-start">
            <a href={record?.url} target="_blank" rel="noopener">
              {record?.url}
            </a>
            <a href={attachment?.url} target="_blank" rel="noopener">
              {attachment?.name}
            </a>
          </Flex>
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("thesis_member", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteThesisMember(index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const thesisResultColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_thesis_result")}`,
      dataIndex: "result",
    },
    {
      title: `${t("str_thesis_result_proof")}`,
      key: "result",
      render: (value, record) => {
        let attachment = null;
        if (record?.attachment?.id) attachment = record?.attachment;
        else {
          let uploadedImages = [];
          if (localStorage.getItem("uploaded_images")) {
            uploadedImages = JSON.parse(
              localStorage.getItem("uploaded_images")
            );
          }
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === record?.attachment);
            attachment = img;
          }
        }

        return (

          < Flex direction="column" alignItems="flex-start" >
            <a href={record.attachment?.[0]?.url} target="_blank" rel="noopener">
              {record?.attachment?.[0]?.name || record?.attachment?.name}
            </a>
          </Flex >
        );
      },
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("thesis_result", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  onConfirm={() => handleDeleteThesisResult(index)}
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );

        return null;
      },
    },
  ];

  const scienceProfileColumns = [
    {
      title: `${t("str_ordinal_number")}`,
      key: "index",
      render: (value, record, index) =>
        (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: `${t("str_proof_of_ability")}`,
      key: "name",
      render: (value, record, index) => t(record?.name),
    },
    {
      title: `${t("str_link_attachment")}`,
      key: "url",
      render: (value, record) => {
        if (record?.url !== null && record?.url !== "")
          return (
            <a href={record?.url} download target="_blank" rel="noreferrer">
              {record?.url}
            </a>
          );
        return <span>{record?.url}</span>;
      },
    },
    {
      title: "",
      key: "action",
      render: (value, record, index) => {
        if (!isSecretariatView)
          return (
            <Flex>
              <Box>
                <IconButton
                  onClick={() =>
                    handleShowModal("instructor_detail", record, index)
                  }
                  label="Update"
                  noBorder
                  icon={<EditOutlined />}
                />
              </Box>
              <Box paddingLeft={1}>
                <Popconfirm
                  title={t("str_confirm")}
                  description={t("str_confirm_delete")}
                  onConfirm={() => handleDeleteInstructorDetail(index)}
                  okText={t("str_yes")}
                  cancelText={t("str_no")}
                >
                  <IconButton noBorder icon={<DeleteOutlined />} />
                </Popconfirm>
              </Box>
            </Flex>
          );
        return null;
      },
    },
  ];
  //#endregion

  useEffect(() => {
    if (i18n.language === "en") setDownloadTemplate(TemplateEn);
    else setDownloadTemplate(Template);
  }, [i18n.language]);

  useEffect(() => {
    if (dataForUpdate?.thesis?.summary) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.thesis?.summary?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });
      setFileList([...tmp]);
    } else {
      setFileList([]);
    }
  }, [dataForUpdate?.thesis?.summary]);

  //#region Update info
  const handleSetThesisName = (name) => {
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate.thesis, name },
    });
  };

  const handleSetSchool = (school) => {
    setDataForUpdate({
      ...dataForUpdate,
      school,
    });
  };

  const handleSetSpecialization = (specialization) => {
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate.thesis, specialization },
    });
  };

  const handleSetYearOfProtection = (year_of_protection) => {
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate.thesis, year_of_protection },
    });
  };

  const handleChangeThesisSummary = (resFile) => {
    let temp = [...(dataForUpdate?.thesis?.summary || [])];
    temp.push(resFile?.id);
    setDataForUpdate({
      ...dataForUpdate,
      thesis: {
        ...dataForUpdate?.thesis,
        summary: [...temp],
      },
    });
  };

  const handleSetInstructureName = (instructor_name) => {
    setDataForUpdate({ ...dataForUpdate, instructor_name });
  };

  const handleSetInstructorDegree = (instructor_degree) => {
    setDataForUpdate({ ...dataForUpdate, instructor_degree });
  };

  const handleSetInstructorWorkingUnit = (instructor_working_unit) => {
    setDataForUpdate({ ...dataForUpdate, instructor_working_unit });
  };

  const handleSetInstructorEmail = (instructor_email) => {
    setDataForUpdate({ ...dataForUpdate, instructor_email });
  };

  const handleSetInstructorPhone = (instructor_phone) => {
    setDataForUpdate({ ...dataForUpdate, instructor_phone });
  };

  const handleSetInstructorAddress = (instructor_address) => {
    setDataForUpdate({ ...dataForUpdate, instructor_address });
  };

  const handleSetInstructorUrl = (instructor_url) => {
    setDataForUpdate({ ...dataForUpdate, instructor_url });
  };

  const handleSetSchoolAddress = (school_address) => {
    setDataForUpdate({ ...dataForUpdate, school_address });
  };

  const handleSetSchoolWebsite = (school_website) => {
    setDataForUpdate({ ...dataForUpdate, school_website });
  };
  //#endregion

  //#region Modal
    const handleShowModal = (key, object = null, index = null) => {
      setKey(key);
      setCurObject(object);
      switch (key) {
        case infoList.school_ranking:
          setCurIndex(object ? index + (rankingCurrentPage - 1) * pageSizeTable : index);
          if (index === 0) {
            setModalTitle(t("str_school_ranking"));
          } else if (index === 1) {
            setModalTitle(t("str_ranking_nominee_major"));
          }
          break;
        case infoList.thesis_member:
          setCurIndex(object ? index + (membersCurrentPage - 1) * pageSizeTable : index);
          setModalTitle(t("str_list_thesis_committee"));
          break;
        case infoList.thesis_result:
          setCurIndex(object ? index + (thesisResultsCurrentPage - 1) * pageSizeTable : index);
          setModalTitle(t("str_list_thesis_result"));
          break;
        case infoList.instructor_detail:
          setCurIndex(object ? index + (instructorDetailCurrentPage - 1) * pageSizeTable : index);
          setModalTitle("");
          break;
        default:
          setModalTitle("");
          break;
      }

      setShowModal(true);
    };

    const handleCloseModal = () => {
      setCurObject(null);
      setCurIndex(null);
      setShowModal(false);
    };

    const handleSubmitModal = () => {
      let temp = [];
      switch (key) {
        case infoList.school_ranking:
          temp = [...(dataForUpdate?.thesis?.school_rankings || [])];
          if (curIndex !== null && curIndex > -1) {
            temp[curIndex] = { ...curObject };
          } else {
            temp.push(curObject);
          }

          setDataForUpdate({
            ...dataForUpdate,
            thesis: {
              ...dataForUpdate.thesis,
              school_rankings: [...temp],
            },
          });
          break;
        case infoList.thesis_member:
          temp = [...(dataForUpdate?.thesis?.members || [])];
          if (curIndex !== null && curIndex > -1) {
            temp[curIndex] = { ...curObject };
          } else {
            temp.push(curObject);
          }

          setDataForUpdate({
            ...dataForUpdate,
            thesis: {
              ...dataForUpdate.thesis,
              members: [...temp],
            },
          });
          break;
        case infoList.thesis_result:
          temp = [...(dataForUpdate?.thesis?.thesis_results || [])];
          if (curIndex !== null && curIndex > -1) {
            temp[curIndex] = { ...curObject };
          } else {
            temp.push(curObject);
          }

          setDataForUpdate({
            ...dataForUpdate,
            thesis: {
              ...dataForUpdate.thesis,
              thesis_results: [...temp],
            },
          });
          break;
        case infoList.instructor_detail:
          temp = [...(dataForUpdate?.instructor_detail || [])];
          if (curIndex !== null && curIndex > -1) {
            temp[curIndex] = { ...curObject };
          } else {
            temp.push(curObject);
          }

          setDataForUpdate({
            ...dataForUpdate,
            instructor_detail: [...temp],
          });
          break;
        default:
          break;
      }

      setCurObject(null);
      setCurIndex(null);
      setKey(null);
      setShowModal(false);
    };
  //#endregion

  const handleDeleteRanking = (index) => {
    let temp = [...dataForUpdate?.thesis?.school_rankings];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate?.thesis, school_rankings: [...temp] },
    });
  };


  const handleDeleteThesisMember = async (index) => {
    let temp = [...dataForUpdate?.thesis?.members];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate?.thesis, members: [...temp] },
    });
  };

  const handleDeleteThesisResult = async (index) => {
    let temp = [...dataForUpdate?.thesis?.thesis_results];
    temp.splice(index, 1);
    setDataForUpdate({
      ...dataForUpdate,
      thesis: { ...dataForUpdate?.thesis, thesis_results: [...temp] },
    });
  };

  const handleDeleteInstructorDetail = (index) => {
    let temp = [...dataForUpdate?.instructor_detail];

    if (index < 3) {
      temp[index]["url"] = "";
    } else {
      temp.splice(index, 1);
    }

    setDataForUpdate({
      ...dataForUpdate,
      instructor_detail: [...temp],
    });
  };

  const handleRemoveAttachment = (id) => {
    let tmp = [...dataForUpdate?.thesis?.summary];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({
        ...dataForUpdate,
        thesis: { ...dataForUpdate.thesis, summary: [...tmp] },
      });
    }
  };

  const phoneValidation = () => {
    let error = "";
    error =
      !dataForUpdate?.instructor_phone ||
        dataForUpdate?.instructor_phone === "" ||
        dataForUpdate?.instructor_phone === null
        ? t("str_required_phone_number")
        : "";

    error = isValidPhoneNumber(dataForUpdate?.instructor_phone)
      ? t("str_phone_invalid")
      : "";

    return error;
  };

  return (
    <div>
      <Row gutter={[8, 16]}>
        <Col span={24}>
          <Card
            title={
              <span style={{ color: blue.primary }}>
                {t("str_training_institution_information")}
              </span>
            }
          >
            <Grid gap={5}>
              <GridItem padding={1} col={4} s={6} xs={12}>
                <Field
                  name="school"
                  error={
                    !dataForUpdate?.school || dataForUpdate?.school === ""
                      ? t("str_required_academic_institution_name")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_academic_institution_name")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.school}
                    onChange={(e) => handleSetSchool(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem padding={1} col={4} s={6} xs={12}>
                <Field
                  name="school_address"
                  error={
                    !dataForUpdate?.school_address ||
                      dataForUpdate?.school_address === ""
                      ? t("str_required_academic_institution_address")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_nominee_address")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.school_address}
                    onChange={(e) => handleSetSchoolAddress(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem padding={1} col={4} s={6} xs={12}>
                <Field
                  name="school_website"
                  error={
                    !dataForUpdate?.school_website ||
                      dataForUpdate?.school_website === ""
                      ? t("str_required_academic_institution_website")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    Website
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.school_website}
                    onChange={(e) => handleSetSchoolWebsite(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem padding={1} col={12}>
                <Typography variant="omega" fontWeight="bold">
                  {t("str_ranking_of_training_facility")}
                </Typography>
                <Table
                  rowKey="id"
                  columns={rankingColumns}
                  dataSource={dataForUpdate?.thesis?.school_rankings}
                  scroll={{ x: "1000px" }}
                  pagination={{
                    onChange: (page, pageSize) => {
                      setRankingCurrentPage(page);
                    }
                  }}
                  footer={() => {
                    if (!isSecretariatView)
                      return (
                        <Button
                          type="link"
                          icon={<PlusCircleOutlined />}
                          onClick={() =>
                            handleShowModal("school_ranking", null, dataForUpdate?.thesis?.school_rankings?.length)
                          }
                        >
                          {t("str_add_ranking_of_training_facility")}
                        </Button>
                      );

                    return null;
                  }}
                />
              </GridItem>
            </Grid>
          </Card>
        </Col>

        <Col span={24}>
          <Card
            title={
              <span style={{ color: blue.primary }}>
                {t("str_nominated_thesis_information")}
              </span>
            }
          >
            <Grid gap={5}>
              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="thesis_name"
                  error={
                    !dataForUpdate?.thesis?.name ||
                      dataForUpdate?.thesis?.name === ""
                      ? t("str_required_thesis_title")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_thesis_name")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.thesis?.name}
                    onChange={(e) => handleSetThesisName(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="specialization"
                  error={
                    !dataForUpdate?.thesis?.specialization ||
                      dataForUpdate?.thesis?.specialization === ""
                      ? t("str_required_major")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_thesis_majors")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.thesis?.specialization}
                    onChange={(e) => handleSetSpecialization(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={12} xs={12}>
                <Field
                  name="year_of_protection"
                  error={
                    !dataForUpdate?.thesis?.year_of_protection ||
                      dataForUpdate?.thesis?.year_of_protection === ""
                      ? t("str_required_year_of_thesis_defense")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_year_of_thesis_defense")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.thesis?.year_of_protection}
                    onChange={(e) => handleSetYearOfProtection(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem padding={1} col={12}>
                <Typography variant="omega" fontWeight="bold">
                  {t("str_nominated_thesis_information_new")}
                  <span className="subnotes">*</span>
                </Typography>
                {isSecretariatView && (
                  <UploadFile
                    fileMimeType={[
                      "application/pdf",
                      "application/msword",
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    ]}
                    fileTypeAllowNames="pdf/doc/docx"
                    fileList={fileList}
                    disabled={true}
                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />)}
                {!isSecretariatView && (
                  <>
                    <a
                      href={downloadTemplate}
                      download="Bieu_mau_noi_dung_tom_tat_luan_an.docx"
                      style={{ marginLeft: "15px", fontSize: "12px" }}
                    >
                      {t("str_download_template")}
                    </a>
                    <br />
                    <span className="subnotes">{t("str_file_pdf_word")}</span>
                    <br />
                    <UploadFile
                      fileMimeType={[
                        "application/pdf",
                        "application/msword",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      ]}
                      fileTypeAllowNames="pdf/doc/docx"
                      handleUploadSuccess={handleChangeThesisSummary}
                      fileList={fileList}
                      handleRemoveFile={handleRemoveAttachment}
                      accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    />
                  </>
                )}
              </GridItem>
            </Grid>
          </Card>
        </Col>

        <Col span={24}>
          <Card
            title={
              <span style={{ color: blue.primary }}>
                {t("str_advisor_information")}
              </span>
            }
          >
            <Grid gap={5}>
              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="instructor_name"
                  error={
                    !dataForUpdate?.instructor_name ||
                      dataForUpdate?.instructor_name === ""
                      ? t("str_required_full_name")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_full_name")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_name}
                    onChange={(e) => handleSetInstructureName(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="instructor_degree"
                  error={
                    !dataForUpdate?.instructor_degree ||
                      dataForUpdate?.instructor_degree === ""
                      ? t("str_required_academic_rank_and_degree")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_advisor_degree")}
                  </FieldLabel>
                  <DegreeSelect
                    lang={t("str_lang")}
                    value={dataForUpdate?.instructor_degree}
                    onChange={handleSetInstructorDegree}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="instructor_working_unit"
                  error={
                    !dataForUpdate?.instructor_working_unit ||
                      dataForUpdate?.instructor_working_unit === ""
                      ? t("str_required_working_place")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_workplace")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_working_unit}
                    onChange={(e) =>
                      handleSetInstructorWorkingUnit(e.target.value)
                    }
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="instructor_email"
                  error={
                    !dataForUpdate?.instructor_email ||
                      dataForUpdate?.instructor_email === ""
                      ? t("str_required_email")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    Email
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_email}
                    onChange={(e) => handleSetInstructorEmail(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="phone"
                  error={
                    !dataForUpdate?.instructor_phone ||
                      dataForUpdate?.instructor_phone === "" ||
                      dataForUpdate?.instructor_phone === null
                      ? t("str_required_phone_number")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_nominee_phone_number")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_phone}
                    onChange={(e) => handleSetInstructorPhone(e.target.value)}
                    disabled={isSecretariatView}
                    pattern="^\+?[0-9]{1,4}[-\s.]?(\(?[0-9]+\)?[-\s.]?){4,}$" // Set the pattern attribute for HTML5 validation
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={6} xs={12}>
                <Field
                  name="instructor_address"
                  error={
                    !dataForUpdate?.instructor_address ||
                      dataForUpdate?.instructor_address === ""
                      ? t("str_required_contact_address")
                      : ""
                  }
                >
                  <FieldLabel required style={{ marginBottom: "5px" }}>
                    {t("str_nominator_address")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_address}
                    onChange={(e) => handleSetInstructorAddress(e.target.value)}
                    disabled={isSecretariatView}
                  />
                  <FieldError />
                </Field>
              </GridItem>

              <GridItem col={4} s={12} xs={12}>
                <Field name="instructor_url">
                  <FieldLabel style={{ marginBottom: "5px" }}>
                    {t("str_personal_page_link")}
                  </FieldLabel>
                  <FieldInput
                    value={dataForUpdate?.instructor_url}
                    onChange={(e) => handleSetInstructorUrl(e.target.value)}
                    disabled={isSecretariatView}
                  />
                </Field>
              </GridItem>

              <GridItem col={12}>
                <Table
                  rowKey="id"
                  columns={scienceProfileColumns}
                  dataSource={dataForUpdate?.instructor_detail}
                  scroll={{ x: "1000px" }}
                  pagination={{
                    onChange: (page, pageSize) => {
                      setInstructorDetailCurrentPage(page);
                    },
                  }}
                  footer={() => {
                    if (!isSecretariatView)
                      return (
                        <Button
                          type="link"
                          icon={<PlusCircleOutlined />}
                          onClick={() => handleShowModal("instructor_detail", null, dataForUpdate?.instructor_detail?.length)}
                        >
                          {t("str_add_proof_of_expertise")}
                        </Button>
                      );

                    return null;
                  }}
                />
              </GridItem>
            </Grid>
          </Card>
        </Col>

        <Col span={24}>
          <Card
            title={
              <>
                <span
                  style={{ color: blue.primary, textTransform: "uppercase" }}
                >
                  {t("str_list_thesis_committee")}
                </span>
              </>
            }
          >
            <Table
              rowKey="id"
              columns={thesisMemberColumns}
              dataSource={dataForUpdate?.thesis?.members}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setMembersCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("thesis_member", null, dataForUpdate?.thesis?.members?.length)}
                    >
                      {t("str_add_member_thesis_committee")}
                    </Button>
                  );

                return null;
              }}
            />
          </Card>
        </Col>

        <Col span={24}>
          <Card
            title={
              <>
                <span style={{ color: blue.primary, textTransform: "uppercase" }}>
                  {t("str_list_thesis_result")}
                </span>
              </>
            }
          >
            <Table
              rowKey="id"
              columns={thesisResultColumns}
              dataSource={dataForUpdate?.thesis?.thesis_results}
              scroll={{ x: "1000px" }}
              pagination={{
                onChange: (page, pageSize) => {
                  setThesisResultsCurrentPage(page);
                },
              }}
              footer={() => {
                if (!isSecretariatView)
                  return (
                    <Button
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() => handleShowModal("thesis_result", null, dataForUpdate?.thesis?.thesis_results?.length)}
                    >
                      {t("str_add_member_thesis_result")}
                    </Button>
                  );

                return null;
              }}
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title={modalTile}
        open={showModal}
        onCancel={handleCloseModal}
        onOk={handleSubmitModal}
        okText={t("str_save")}
        cancelText={t("str_cancel")}
        destroyOnClose
      >
        {key === infoList.school_ranking && (
          <SchoolRanking data={curObject} setData={setCurObject} />
        )}
        {key === infoList.thesis_member && (
          <ThesisMember data={curObject} setData={setCurObject} />
        )}
        {key === infoList.thesis_result && (
          <ThesisResult data={curObject} setData={setCurObject} />
        )}
        {key === infoList.instructor_detail && (
          <Prizesv2 data={curObject} setData={setCurObject} />
        )}
      </Modal>
    </div>
  );
};

export default ThesisTab;
